<template>
  <section class="section-base">
    <div class="section-base__title-box">
      <div class="section-base__title">
        {{ RouteText.NOTIFICATIONS_DOCUMENTS }}
      </div>
    </div>
    <NotificationsDocumentsList />
  </section>
</template>

<script>
import { RouteText } from '@/router';
import NotificationsDocumentsList from '@/components/profile/notifications-documents/NotificationsDocumentsList.vue'

export default {
  name: 'NotificationsDocuments',
  components: {
    NotificationsDocumentsList,
  },
  data: () => ({
    RouteText,
  }),
};
</script>
